export const fetchQuestionScore = resp => ({
  type: 'FETCH_QUESTION_SCORE',
  payload: resp,
});
